import { render, staticRenderFns } from "./DText.vue?vue&type=template&id=9810f666&scoped=true&"
import script from "./DText.vue?vue&type=script&lang=js&"
export * from "./DText.vue?vue&type=script&lang=js&"
import style0 from "./DText.vue?vue&type=style&index=0&id=9810f666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9810f666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9810f666')) {
      api.createRecord('9810f666', component.options)
    } else {
      api.reload('9810f666', component.options)
    }
    module.hot.accept("./DText.vue?vue&type=template&id=9810f666&scoped=true&", function () {
      api.rerender('9810f666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/operation/DText.vue"
export default component.exports